import { render } from "./PaymentsManager.vue?vue&type=template&id=a9516770"
import script from "./PaymentsManager.vue?vue&type=script&lang=js"
export * from "./PaymentsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__